/**
 * @file main.jsx
 * @description Haupteinstiegspunkt der gesamten React-Webanwendung.
 *
 * Was hier passiert:
 * 1. Lädt globale CSS-Styles (`index.css`).
 * 2. Hängt die React-Anwendung in das `<div id="root">`-Element des HTML-Dokuments ein.
 * 3. Kapselt die Anwendung in den globalen `AuthProvider` (Login- und Rechteverwaltung)
 *    und den `BrowserRouter` (Seitennavigation ohne Seitenneuladen).
 */

import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.jsx'
import { AuthProvider } from './context/AuthContext.jsx'
import './index.css'

// Initialisierung des React-Roots im HTML-Element mit der ID 'root'
function mountApp() {
  const rootElement = document.getElementById('root');
  if (!rootElement) {
    console.error('ThekenOS: Root-Element #root nicht im DOM gefunden.');
    return;
  }

  ReactDOM.createRoot(rootElement).render(
    <AuthProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AuthProvider>,
  );
}

// Defensives Timing: Sicherstellen, dass das DOM vollständig geladen ist
if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountApp);
  } else {
    mountApp();
  }
}

